import { useState } from 'react';
import { MutatingDots } from 'react-loader-spinner';
import { Link, useNavigate } from 'react-router-dom';
import baseAPI from '../services/api';
import { Container, Footnote, Forms } from '../style/style';

export default function Signup() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pwConfirmation, setPwConfirmation] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  function handleSignUp(e) {
    e.preventDefault();
    setIsLoading(true);
    if (pwConfirmation !== password) {
      alert('As senhas não são compatíveis!');
      setPassword('');
      setPwConfirmation('');
      return;
    }

    const promise = baseAPI.post('/sign-up', {
      name,
      email,
      password,
    });
    promise.then((response) => {
      alert(response.data);
      setIsLoading(false);

      navigate('/');
    });
    promise.catch((error) => {
      setIsLoading(false);
      alert(error);
    });
  }
  return (
    <Container>
      <div className="logo">
        <svg
          width="145"
          height="31"
          viewBox="0 0 145 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0800002 2.944V1.984H5.968L15.184 21.568L14.128 24H9.968L0.0800002 2.944ZM18.16 14.752H18.032L15.888 19.936L13.136 14.048L18.16 1.984H24.24V24H18.16V14.752ZM0.0800002 6.112L5.968 18.656V24H0.0800002V6.112ZM32.7765 23.904C30.8565 23.904 29.5658 23.3173 28.9045 22.144C28.6058 21.632 28.4032 21.0133 28.2965 20.288C28.1898 19.5413 28.1365 18.6347 28.1365 17.568V7.68H34.0565V15.072C34.0565 16.2027 34.0672 16.9493 34.0885 17.312C34.1312 17.8667 34.1952 18.2507 34.2805 18.464C34.3658 18.6987 34.5045 18.848 34.6965 18.912C34.8885 18.9547 35.2298 18.976 35.7205 18.976H36.0405V22.944C35.1872 23.584 34.0992 23.904 32.7765 23.904ZM34.9845 30.592C33.8752 30.592 32.5738 30.528 31.0805 30.4L29.2245 30.208V26.08H33.5125C34.2805 26.08 35.0272 26.0587 35.7525 26.016C36.2645 25.9733 36.6378 25.8667 36.8725 25.696C37.1285 25.5467 37.2778 25.28 37.3205 24.896C37.3632 24.384 37.3845 23.84 37.3845 23.264V7.68H43.3045V22.208C43.3045 23.9147 43.2298 25.2373 43.0805 26.176C42.9525 27.1147 42.6432 27.8933 42.1525 28.512C41.5978 29.216 40.7552 29.7387 39.6245 30.08C38.4938 30.4213 36.9472 30.592 34.9845 30.592ZM50.437 23.072C50.2877 22.4747 50.0957 21.6427 49.861 20.576L48.997 17.056L48.037 13.024L45.445 1.984H51.813L56.357 24H50.661L50.437 23.072ZM55.461 12.992L57.861 1.984H64.421L69.669 24H64.197L63.941 22.944L63.269 20.16L62.309 16.096C61.9037 14.4533 61.5197 12.8427 61.157 11.264H60.965L59.877 16.096L59.525 17.728C59.4183 18.176 59.3117 18.6027 59.205 19.008C59.1197 19.4133 59.0343 19.7973 58.949 20.16L58.309 22.944L58.053 24H57.701L55.461 12.992ZM68.389 12.8L70.309 1.984H76.677L74.053 13.024L73.093 17.056C72.6877 18.6987 72.4103 19.872 72.261 20.576L71.653 23.072L71.429 24H71.045L68.389 12.8ZM86.551 13.888C86.551 13.3333 86.5297 12.9387 86.487 12.704C86.4443 12.4693 86.3163 12.2987 86.103 12.192C85.911 12.0853 85.5483 12.0107 85.015 11.968C84.695 11.9467 84.0017 11.936 82.935 11.936C81.911 11.936 80.9617 11.9787 80.087 12.064L78.391 12.16V8C80.3963 7.616 82.5617 7.424 84.887 7.424C86.679 7.424 88.0763 7.552 89.079 7.808C90.103 8.064 90.871 8.46933 91.383 9.024C91.831 9.536 92.119 10.1867 92.247 10.976C92.3963 11.7653 92.471 12.864 92.471 14.272V24H86.551V13.888ZM81.815 24.224C80.343 24.224 79.255 23.8187 78.551 23.008C77.847 22.176 77.495 20.928 77.495 19.264C77.495 18.24 77.5697 17.4187 77.719 16.8C77.8683 16.16 78.1243 15.6587 78.487 15.296C78.8497 14.912 79.351 14.6453 79.991 14.496C80.631 14.3253 81.4737 14.24 82.519 14.24L85.207 14.304V17.152H84.887C84.3963 17.152 84.0763 17.1627 83.927 17.184C83.5003 17.2053 83.2763 17.408 83.255 17.792C83.2337 17.92 83.223 18.1867 83.223 18.592C83.223 18.912 83.2337 19.1573 83.255 19.328C83.2977 19.4987 83.3617 19.6373 83.447 19.744C83.5537 19.8933 83.7137 19.9787 83.927 20C84.2257 20.0427 84.5457 20.064 84.887 20.064H85.207V23.328C84.7377 23.6907 84.2363 23.9253 83.703 24.032C83.191 24.16 82.5617 24.224 81.815 24.224ZM96.0428 0.223999H101.963V24H96.0428V0.223999ZM105.605 0.223999H111.525V24H105.605V0.223999ZM121.92 14.24H124.16C124.16 13.0453 124.042 12.2773 123.808 11.936C123.68 11.744 123.509 11.6267 123.296 11.584C123.082 11.52 122.773 11.488 122.368 11.488H121.92V7.424H122.368C124.202 7.424 125.61 7.57333 126.592 7.872C127.594 8.17067 128.33 8.66133 128.8 9.344C129.226 9.94133 129.482 10.7093 129.568 11.648C129.674 12.5867 129.728 13.9947 129.728 15.872V17.152H121.92V14.24ZM123.008 24.256C121.045 24.256 119.498 24.096 118.368 23.776C117.258 23.4347 116.426 22.9013 115.872 22.176C115.381 21.536 115.061 20.7467 114.912 19.808C114.762 18.848 114.688 17.536 114.688 15.872C114.688 14.336 114.741 13.12 114.848 12.224C114.954 11.3067 115.178 10.528 115.52 9.888C115.904 9.184 116.49 8.64 117.28 8.256C118.09 7.85067 119.189 7.59467 120.576 7.488V17.152C120.576 17.8773 120.608 18.4 120.672 18.72C120.736 19.0187 120.885 19.2427 121.12 19.392C121.376 19.5627 121.77 19.6587 122.304 19.68C122.986 19.7227 123.712 19.744 124.48 19.744C125.845 19.744 126.837 19.712 127.456 19.648L129.088 19.52V23.648C128.234 23.904 127.061 24.0747 125.568 24.16C124.842 24.224 123.989 24.256 123.008 24.256ZM131.576 7.68H134.584V2.944H140.504V7.68H144.088V12.192H131.576V7.68ZM134.584 13.472H140.504V24H134.584V13.472Z"
            fill="white"
          />
        </svg>
      </div>

      <Forms onSubmit={handleSignUp}>
        <input
          type="text"
          name=""
          placeholder="Nome"
          required
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <input
          type="email"
          name=""
          placeholder="Email"
          required
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <input
          type="password"
          name=""
          placeholder="Senha"
          required
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <input
          type="password"
          name=""
          placeholder="Confirme a senha"
          required
          value={pwConfirmation}
          onChange={(e) => {
            setPwConfirmation(e.target.value);
          }}
        />
        <button disabled={isLoading} type="submit">
          {isLoading ? (
            <MutatingDots
              height={90}
              width={90}
              color="#fff"
              secondaryColor="#a7ecf8"
            />
          ) : (
            <p>Cadastrar</p>
          )}
        </button>
      </Forms>

      <Link to="/">
        <Footnote>Já tem uma conta? Entre agora!</Footnote>
      </Link>
    </Container>
  );
}
